import axios from 'axios';
import { ENDPOINTS } from './ENDPOINTS';

export const SEOServices = {

    addSEODetails: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.SEO_DETAILS, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    updateSEODetails: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.SEO_DETAILS}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
  
    getSEODetialById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.SEO_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
   
    // page content services

     addPCDetails: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.PC_DETAILS, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    updatePCDetails: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.PC_DETAILS}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
  
    getPCDetialById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.PC_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

}